import cx from 'classnames';
import { useIntl } from 'react-intl';

import { LocalHeroMark } from '../../../design-system/components/local-hero/LocalHeroMark';
import { LocalHeroBadge } from '../../../shared/components/LocalHero/Badge/LocalHeroBadge';

import style from './LocalHeroBlockInfo.module.css';

const LOCAL_HERO_LIST = ['support', 'notations', 'engagement'] as const;

export const LocalHeroBlockInfo = () => {
    const { formatMessage } = useIntl();

    return (
        <div className={style.container}>
            <div className={style.localHeroContainer}>
                <LocalHeroBadge />
            </div>
            <p className={cx(style.tilte, 'font-secondary-m-bold')}>
                {formatMessage({ id: 'page.itinerariesList.localHero.title' })}
            </p>
            <p className={cx('font-body-bold', style.subTitle)}>
                {formatMessage({ id: 'page.itinerariesList.localHero.description' })}
            </p>
            <div className={style.list}>
                {LOCAL_HERO_LIST.map((item) => (
                    <div className={style.listBlock} key={item}>
                        <LocalHeroMark />
                        <p className="font-xs-regular">
                            {formatMessage({
                                id: `page.itinerariesList.localHero.${item}`,
                            })}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};
